<p500-ui-checkbox-field [formControl]="control || innerControl" [label]="label" [disabled]="disabled">
  <ng-template p500UIFieldLabel>
    <span class="p500-ui-form-field__label">
      {{ label }}
    </span>
    <span
      *ngIf="hintModal"
      class="p500-ui-form-field__hint"
      p500UITooltip
      i18n-tooltipData="@@common.click_for_description"
      tooltipData="Click for description"
      (click)="$event.preventDefault(); openTooltipModal()"
      >?</span
    >
  </ng-template>
</p500-ui-checkbox-field>
